/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { HitsNotification } from "../models/hitsNotification";

import type { MarkAsOpenParams } from "../models/markAsOpenParams";

import type { MarkAsReadParams } from "../models/markAsReadParams";

import type { PushTokenRegistrationRequest } from "../models/pushTokenRegistrationRequest";

import type { Query } from "../models/query";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Delete All Notifications
 */
export const deleteAllNotifications = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    { url: `/api/notification/deleteAll`, method: "POST", signal },
    options,
  );
};

export const getDeleteAllNotificationsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAllNotifications>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAllNotifications>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["deleteAllNotifications"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAllNotifications>>,
    void
  > = (_, context) => {
    return deleteAllNotifications({
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAllNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAllNotifications>>
>;

export type DeleteAllNotificationsMutationError = ErrorType<unknown>;

/**
 * @summary Delete All Notifications
 */
export const useDeleteAllNotifications = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAllNotifications>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAllNotifications>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteAllNotificationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary De Register Push Token
 */
export const deRegisterPushToken = (
  pushTokenRegistrationRequest: PushTokenRegistrationRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<boolean>(
    {
      url: `/api/notification/deregister-push-token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pushTokenRegistrationRequest,
      signal,
    },
    options,
  );
};

export const getDeRegisterPushTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deRegisterPushToken>>,
    TError,
    { data: PushTokenRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deRegisterPushToken>>,
  TError,
  { data: PushTokenRegistrationRequest },
  TContext
> => {
  const mutationKey = ["deRegisterPushToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deRegisterPushToken>>,
    { data: PushTokenRegistrationRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return deRegisterPushToken(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DeRegisterPushTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof deRegisterPushToken>>
>;
export type DeRegisterPushTokenMutationBody = PushTokenRegistrationRequest;
export type DeRegisterPushTokenMutationError = ErrorType<unknown>;

/**
 * @summary De Register Push Token
 */
export const useDeRegisterPushToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deRegisterPushToken>>,
      TError,
      { data: PushTokenRegistrationRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deRegisterPushToken>>,
  TError,
  { data: PushTokenRegistrationRequest },
  TContext
> => {
  const mutationOptions = getDeRegisterPushTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Mark As Open
 */
export const markAsOpen = (
  params?: MarkAsOpenParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<boolean>(
    { url: `/api/notification/markAsOpen`, method: "POST", params, signal },
    options,
  );
};

export const getMarkAsOpenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAsOpen>>,
    TError,
    { params?: MarkAsOpenParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAsOpen>>,
  TError,
  { params?: MarkAsOpenParams },
  TContext
> => {
  const mutationKey = ["markAsOpen"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAsOpen>>,
    { params?: MarkAsOpenParams }
  > = (props, context) => {
    const { params } = props ?? {};

    return markAsOpen(params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAsOpenMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAsOpen>>
>;

export type MarkAsOpenMutationError = ErrorType<unknown>;

/**
 * @summary Mark As Open
 */
export const useMarkAsOpen = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAsOpen>>,
      TError,
      { params?: MarkAsOpenParams },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markAsOpen>>,
  TError,
  { params?: MarkAsOpenParams },
  TContext
> => {
  const mutationOptions = getMarkAsOpenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Mark As Read
 */
export const markAsRead = (
  params?: MarkAsReadParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    { url: `/api/notification/markAsRead`, method: "POST", params, signal },
    options,
  );
};

export const getMarkAsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAsRead>>,
    TError,
    { params?: MarkAsReadParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAsRead>>,
  TError,
  { params?: MarkAsReadParams },
  TContext
> => {
  const mutationKey = ["markAsRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAsRead>>,
    { params?: MarkAsReadParams }
  > = (props, context) => {
    const { params } = props ?? {};

    return markAsRead(params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAsRead>>
>;

export type MarkAsReadMutationError = ErrorType<unknown>;

/**
 * @summary Mark As Read
 */
export const useMarkAsRead = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAsRead>>,
      TError,
      { params?: MarkAsReadParams },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markAsRead>>,
  TError,
  { params?: MarkAsReadParams },
  TContext
> => {
  const mutationOptions = getMarkAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Register Push Token
 */
export const registerPushToken = (
  pushTokenRegistrationRequest: PushTokenRegistrationRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<boolean>(
    {
      url: `/api/notification/register-push-token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pushTokenRegistrationRequest,
      signal,
    },
    options,
  );
};

export const getRegisterPushTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerPushToken>>,
    TError,
    { data: PushTokenRegistrationRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerPushToken>>,
  TError,
  { data: PushTokenRegistrationRequest },
  TContext
> => {
  const mutationKey = ["registerPushToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerPushToken>>,
    { data: PushTokenRegistrationRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return registerPushToken(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterPushTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerPushToken>>
>;
export type RegisterPushTokenMutationBody = PushTokenRegistrationRequest;
export type RegisterPushTokenMutationError = ErrorType<unknown>;

/**
 * @summary Register Push Token
 */
export const useRegisterPushToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerPushToken>>,
      TError,
      { data: PushTokenRegistrationRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerPushToken>>,
  TError,
  { data: PushTokenRegistrationRequest },
  TContext
> => {
  const mutationOptions = getRegisterPushTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find Notifications
 */
export const findNotifications = (
  query: Query,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsNotification>(
    {
      url: `/api/notification/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: query,
      signal,
    },
    options,
  );
};

export const getFindNotificationsInfiniteQueryKey = (query?: Query) => {
  return ["infinite", `/api/notification/search`, query] as const;
};

export const getFindNotificationsQueryKey = (query?: Query) => {
  return [`/api/notification/search`, query] as const;
};

export const getFindNotificationsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof findNotifications>>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindNotificationsInfiniteQueryKey(query);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findNotifications>>
  > = ({ signal, meta }) =>
    findNotifications(query, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof findNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindNotificationsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof findNotifications>>
>;
export type FindNotificationsInfiniteQueryError = ErrorType<unknown>;

export function useFindNotificationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof findNotifications>>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNotifications>>,
          TError,
          Awaited<ReturnType<typeof findNotifications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindNotificationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof findNotifications>>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNotifications>>,
          TError,
          Awaited<ReturnType<typeof findNotifications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindNotificationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof findNotifications>>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Notifications
 */

export function useFindNotificationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof findNotifications>>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindNotificationsInfiniteQueryOptions(query, options);

  const _query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  _query.queryKey = queryOptions.queryKey;

  return _query;
}

/**
 * @summary Find Notifications
 */
export const prefetchFindNotificationsInfinite = async <
  TData = Awaited<ReturnType<typeof findNotifications>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  query: Query,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindNotificationsInfiniteQueryOptions(query, options);

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
};

export const getFindNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof findNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindNotificationsQueryKey(query);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findNotifications>>
  > = ({ signal, meta }) =>
    findNotifications(query, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof findNotifications>>
>;
export type FindNotificationsQueryError = ErrorType<unknown>;

export function useFindNotifications<
  TData = Awaited<ReturnType<typeof findNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNotifications>>,
          TError,
          Awaited<ReturnType<typeof findNotifications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindNotifications<
  TData = Awaited<ReturnType<typeof findNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findNotifications>>,
          TError,
          Awaited<ReturnType<typeof findNotifications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindNotifications<
  TData = Awaited<ReturnType<typeof findNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Notifications
 */

export function useFindNotifications<
  TData = Awaited<ReturnType<typeof findNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindNotificationsQueryOptions(query, options);

  const _query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  _query.queryKey = queryOptions.queryKey;

  return _query;
}

/**
 * @summary Find Notifications
 */
export const prefetchFindNotifications = async <
  TData = Awaited<ReturnType<typeof findNotifications>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindNotificationsQueryOptions(query, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Find Unread Notifications
 */
export const findUnreadNotifications = (
  query: Query,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<HitsNotification>(
    {
      url: `/api/notification/searchUnread`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: query,
      signal,
    },
    options,
  );
};

export const getFindUnreadNotificationsQueryKey = (query?: Query) => {
  return [`/api/notification/searchUnread`, query] as const;
};

export const getFindUnreadNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof findUnreadNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findUnreadNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindUnreadNotificationsQueryKey(query);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof findUnreadNotifications>>
  > = ({ signal, meta }) =>
    findUnreadNotifications(query, { ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof findUnreadNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindUnreadNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof findUnreadNotifications>>
>;
export type FindUnreadNotificationsQueryError = ErrorType<unknown>;

export function useFindUnreadNotifications<
  TData = Awaited<ReturnType<typeof findUnreadNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findUnreadNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findUnreadNotifications>>,
          TError,
          Awaited<ReturnType<typeof findUnreadNotifications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindUnreadNotifications<
  TData = Awaited<ReturnType<typeof findUnreadNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findUnreadNotifications>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findUnreadNotifications>>,
          TError,
          Awaited<ReturnType<typeof findUnreadNotifications>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFindUnreadNotifications<
  TData = Awaited<ReturnType<typeof findUnreadNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findUnreadNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find Unread Notifications
 */

export function useFindUnreadNotifications<
  TData = Awaited<ReturnType<typeof findUnreadNotifications>>,
  TError = ErrorType<unknown>,
>(
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findUnreadNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFindUnreadNotificationsQueryOptions(query, options);

  const _query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  _query.queryKey = queryOptions.queryKey;

  return _query;
}

/**
 * @summary Find Unread Notifications
 */
export const prefetchFindUnreadNotifications = async <
  TData = Awaited<ReturnType<typeof findUnreadNotifications>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  query: Query,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof findUnreadNotifications>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getFindUnreadNotificationsQueryOptions(query, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Unopened Notifications Count
 */
export const getUnopenedNotificationsCount = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<number>(
    { url: `/api/notification/unopenedCount`, method: "GET", signal },
    options,
  );
};

export const getGetUnopenedNotificationsCountQueryKey = () => {
  return [`/api/notification/unopenedCount`] as const;
};

export const getGetUnopenedNotificationsCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUnopenedNotificationsCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUnopenedNotificationsCount>>
  > = ({ signal, meta }) =>
    getUnopenedNotificationsCount({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUnopenedNotificationsCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUnopenedNotificationsCount>>
>;
export type GetUnopenedNotificationsCountQueryError = ErrorType<unknown>;

export function useGetUnopenedNotificationsCount<
  TData = Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
          TError,
          Awaited<ReturnType<typeof getUnopenedNotificationsCount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUnopenedNotificationsCount<
  TData = Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
          TError,
          Awaited<ReturnType<typeof getUnopenedNotificationsCount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUnopenedNotificationsCount<
  TData = Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Unopened Notifications Count
 */

export function useGetUnopenedNotificationsCount<
  TData = Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUnopenedNotificationsCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Unopened Notifications Count
 */
export const prefetchGetUnopenedNotificationsCount = async <
  TData = Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUnopenedNotificationsCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetUnopenedNotificationsCountQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};
